import { inputAnatomy as i } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers as r, defineStyle as o } from "@chakra-ui/react";
import { iconSizes as e } from "../../foundations/icons.mjs";
const { defineMultiStyleConfig: d, definePartsStyle: n } = r(i.keys), a = n({
  field: {
    width: "100%",
    color: "gray.800",
    minWidth: 0,
    outline: 0,
    position: "relative",
    appearance: "none",
    transitionProperty: "common",
    transitionDuration: "normal",
    ":not(.dual-input-right)": {
      ":not(.dual-input-left)": {
        _invalid: {
          _focus: {
            boxShadow: "invalidOutline"
          }
        }
      }
    },
    "&.dual-input-left": {
      _invalid: {
        borderWidth: "2px 0 2px 2px",
        borderColor: "red.500",
        _focus: {
          boxShadow: "invalidOutline"
        }
      }
    },
    "&.dual-input-right": {
      _invalid: {
        borderWidth: "2px 2px 2px 0",
        borderColor: "red.500",
        _focus: {
          boxShadow: "invalidOutline"
        }
      }
    },
    '&[type="search"]::-webkit-search-cancel-button, &[type="search"]::-webkit-search-decoration, &[type="search"]::-webkit-search-results-button, &[type="search"]::-webkit-search-results-decoration': {
      WebkitAppearance: "none"
    },
    '&[type="search"]::-ms-clear, &[type="search"]::-ms-reveal': {
      display: "none",
      width: "0",
      height: "0"
    },
    "&.search-input-with-button": {
      borderRightRadius: "none",
      borderRight: "none"
    }
  },
  element: {
    "&.search-input-left-element-icon": {
      width: "auto",
      color: "gray.400"
    },
    "&.input-clear-element button, &.password-view-toggle button": {
      minWidth: 7,
      minHeight: 7
    },
    ".ccinput-right-icon": {
      color: "gray.400"
    }
  },
  addon: {
    ".currencyinput-left-addon": {
      color: "gray.700"
    }
  }
}), t = {
  md: o({
    textStyle: "body",
    px: 4,
    h: { base: 8, md: 10 },
    borderRadius: "lg",
    "&.search-input-with-button, &.password-input": {
      paddingLeft: "16px",
      paddingRight: { base: "56px", md: "64px" }
    },
    "&.search-input-no-button": {
      paddingLeft: { base: "38px", md: "40px" },
      paddingRight: { base: "56px", md: "64px" }
    },
    "+ .search-input-button": {
      minWidth: { base: 8, md: 10 },
      minHeight: { base: 8, md: 10 },
      fontSize: { base: e.lg, md: e.xl }
    },
    ".currencyinput-left-addon": {
      fontSize: { base: e.sm, md: e.md }
    }
  }),
  sm: o({
    textStyle: "bodySmall",
    px: 3,
    h: { base: 7, md: 8 },
    borderRadius: "lg",
    "&.search-input-with-button, &.password-input": {
      paddingLeft: "12px",
      paddingRight: { base: "48px", md: "52px" }
    },
    "&.search-input-no-button": {
      paddingLeft: { base: "32px", md: "34px" },
      paddingRight: { base: "48px", md: "52px" }
    },
    "+ .search-input-button": {
      minWidth: { base: 7, md: 8 },
      minHeight: { base: 7, md: 8 },
      fontSize: { base: e.sm, md: e.md }
    },
    ".currencyinput-left-addon": {
      fontSize: { base: e.xs, md: e.sm }
    }
  })
}, b = d({
  baseStyle: a,
  sizes: {
    md: {
      field: t.md,
      addon: t.md,
      element: {
        "&.search-input-left-element-icon": {
          marginLeft: 4,
          fontSize: { base: e.sm, md: e.md }
        },
        "&.input-clear-element, &.password-view-toggle": {
          right: 4
        },
        "&.search-button-repos": {
          right: { base: "48px", md: "56px" }
        },
        "&.input-clear-element button, &.password-view-toggle button": {
          width: { base: 8, md: 10 },
          height: { base: 8, md: 10 },
          fontSize: { base: e.lg, md: e.xl }
        },
        "+ .search-input-button": {
          minWidth: { base: 8, md: 10 },
          minHeight: { base: 8, md: 10 },
          fontSize: { base: e.lg, md: e.xl }
        },
        ".ccinput-right-icon": {
          fontSize: e["2xl"]
        }
      }
    },
    sm: {
      field: t.sm,
      addon: t.sm,
      element: {
        "&.search-input-left-element-icon": {
          marginLeft: 3,
          fontSize: { base: e.xs, md: e.sm }
        },
        "&.input-clear-element, &.password-view-toggle": {
          right: 3
        },
        "&.search-button-repos": {
          right: { base: "40px", md: "44px" }
        },
        "&.input-clear-element button, &.password-view-toggle button": {
          width: { base: 7, md: 8 },
          height: { base: 7, md: 8 },
          fontSize: { base: e.sm, md: e.md }
        },
        "+ .search-input-button": {
          minWidth: { base: 7, md: 8 },
          minHeight: { base: 7, md: 8 },
          fontSize: { base: e.sm, md: e.md }
        },
        ".ccinput-right-icon": {
          fontSize: e.xl
        }
      }
    }
  },
  variants: {
    outline: {
      field: {
        border: "1px solid",
        borderColor: "gray.200",
        bg: "inherit",
        _hover: {
          borderColor: "gray.300"
        },
        _focus: {
          borderColor: "teal.500",
          borderWidth: "2px",
          boxShadow: "outline"
        },
        _focusVisible: {
          borderColor: "teal.500",
          borderWidth: "2px"
        },
        _readOnly: {
          userSelect: "all"
        },
        ":not(.dual-input-left)": {
          ":not(.dual-input-right)": {
            _invalid: {
              borderWidth: "2px",
              borderColor: "red.500"
            }
          }
        },
        _disabled: {
          opacity: 0.5,
          cursor: "not-allowed",
          _hover: {
            borderColor: "gray.200"
          }
        }
      },
      addon: {
        border: "1px solid",
        borderColor: "gray.200",
        bg: "gray.100"
      }
    },
    filled: {
      field: {
        border: "1px solid",
        borderColor: "transparent",
        bg: "gray.50",
        _hover: {
          bg: "gray.100"
        },
        _focus: {
          bg: "inherit",
          borderColor: "teal.500",
          borderWidth: "2px",
          boxShadow: "outline"
        },
        _focusVisible: {
          bg: "inherit",
          borderColor: "teal.500",
          borderWidth: "2px"
        },
        _readOnly: {
          boxShadow: "none !important",
          userSelect: "all"
        },
        ":not(.dual-input-right)": {
          ":not(.dual-input-left)": {
            _invalid: {
              borderColor: "red.500",
              bg: "inherit",
              borderWidth: "2px",
              _hover: {
                bg: "inherit"
              }
            }
          }
        },
        _disabled: {
          opacity: 0.5,
          cursor: "not-allowed",
          _hover: {
            bg: "gray.50"
          }
        }
      },
      addon: {
        border: "1px solid",
        borderColor: "transparent",
        bg: "gray.100",
        "~ hr": {
          border: "0px solid",
          borderWidth: "0 0 0 1px",
          borderColor: "gray.200",
          height: "auto"
        }
      }
    }
  },
  defaultProps: {
    size: "md",
    variant: "outline"
  }
});
export {
  b as default
};
